import { DraggableItem } from "../../pages/setting/pages/optionGroup/components/catalogOption/components/draggableItem/types";
import { OptionGroupList, ResponseDropDownLinks } from "./reponse";

const formatCOptionToItems = (data: OptionGroupList): DraggableItem[] => {
    if (!data?.dropDownLinks) return [];

    // Mapea los dropdowns recursivamente
    const mapDropDownLinks = (
        dropDowns: ResponseDropDownLinks[],
        level: number,
    ): DraggableItem[] => {
        return dropDowns.map((drop) => {
            const firstChild = drop.nextValues?.[0];
            const subcatalog =
                firstChild?.parent?.id !== undefined ? firstChild.parent.id : undefined;

            return {
                id: String(drop.currentNode),
                itemSubCatalogId: drop.parent ? drop.currentDropDownId : undefined,
                label: drop.name,
                expand: false,
                level,
                isEditable: !drop.parent, // editable si no tiene padre
                children: mapDropDownLinks(drop.nextValues || [], level + 1),
                priority: undefined,
                provider: undefined,
                subcatalog: subcatalog,
                textInput: drop.requiredText ?? undefined,
            }
        });
    };


    return (data.dropDownLinks || []).flatMap((ddl) => mapDropDownLinks([ddl], 3))
};

const formatOptiongById = ({ response }: { response: OptionGroupList }) => {

    const items = response.errors
        ? [] : formatCOptionToItems(response)

    return {
        items
    }
}



export { formatOptiongById }